import { Container } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { UiPopup } from "../../_uiComponents/common/UiModal";
import { CardLeaveConfirmationPopup } from "./popups/CardLeaveConfirmationPopup";
import { ConfirmationIcon } from "../../../styles/img/svg/ConfirmationIcon";
import renderStep from "./renderSteps";
import { clearCommonErrors } from "../../../_redux/_actions";
import { storeCurrentStepDetails } from "../../../_redux/_actions/onboarding.actions";
import { useSelector } from "react-redux";
import Logo from "../../../styles/img/df-logo.png";
import { onboardingConstants } from "../../../_redux/_constants";

export const OnboardingWrapper = (props) => {
  const { currentStep } = useSelector((state) => state.onboarding);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [showLeavingPopup, setShowLeavingPopup] = useState(false);
  const [isFormDirty, setIsFormDirty] = useState(false);
  const [flowStep, setFlowStep] = useState(currentStep);
  // Ephemeral password — never Redux / sessionStorage
  const ephemeralPasswordRef = useRef("");

  const clearEphemeralPassword = () => {
    ephemeralPasswordRef.current = "";
  };

  const setEphemeralPassword = (password) => {
    ephemeralPasswordRef.current = password || "";
  };

  const getEphemeralPassword = () => ephemeralPasswordRef.current;

  const changeFlowStep = (step) => {
    if (
      step === onboardingConstants.PROCESS_SUCCESSFUL_STEP ||
      step === onboardingConstants.PROCESS_UNSUCCESSFUL_STEP
    ) {
      clearEphemeralPassword();
    }
    setFlowStep(step);
    dispatch(storeCurrentStepDetails({ stepName: step }));
  };

  const cancelBtnClick = () => {
    if (isFormDirty) {
      setShowLeavingPopup(true);
    } else {
      clearEphemeralPassword();
      navigate("/");
    }
  };

  const goToLogin = () => {
    clearEphemeralPassword();
    navigate("/");
  };

  useEffect(() => {
    dispatch(clearCommonErrors());
    return () => {
      clearEphemeralPassword();
    };
  }, []);

  return (
    <>
      <div className="df-logo-nav">
        <Container maxWidth="xl">
          <div className="df-logo-nav__content">
            <img src={Logo} />
          </div>
        </Container>
      </div>
      {renderStep(flowStep, {
        setIsFormDirty: setIsFormDirty,
        cancelBtnClick: cancelBtnClick,
        changeFlowStep: changeFlowStep,
        setEphemeralPassword,
        getEphemeralPassword,
        clearEphemeralPassword,
      })}

      <UiPopup
        openModal={showLeavingPopup}
        handleClose={() => {
          setShowLeavingPopup(false);
        }}
      >
        <CardLeaveConfirmationPopup
          icon={<ConfirmationIcon />}
          message={t("Leaving this page?")}
          buttonOnClickClose={() => {
            setShowLeavingPopup(false);
          }}
          buttonOnClick={goToLogin}
          className="df-confirmation-message-popup df-btn-grpdmodal"
        >
          <p>
            {t(
              "Are you sure you want to leave this page? You have some unsaved changes.",
            )}
          </p>
        </CardLeaveConfirmationPopup>
      </UiPopup>
    </>
  );
};
